import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { billPayload } from "../types";

const fetchBills = async (): Promise<ApiResponse<billPayload[]>> => {
  return apiClient<ApiResponse<billPayload[]>>(`/v1/bills`, {
    method: 'GET'
  });
}

export default fetchBills;